import * as React from "react";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Alert,
  Rating,
  TextField,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../../api";

export const ReviewQuestionDialog = ({
  open,
  setOpen,
  question,
  onSubmitted,
}) => {
  const ApiClient = useApiClient();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    rating: question?.userReview?.rating || 0,
    comment: question?.userReview?.comment || "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submitReview = async () => {
    setLoading(true);
    setError("");

    if (!formState.rating) {
      setError("Please provide a rating");
      setLoading(false);
      return;
    }

    // Check if question is defined before accessing its properties
    if (!question) {
      setError("Question data is missing.");
      setLoading(false);
      return;
    }

    try {
      const response = await ApiClient.question.submitReview({
        question: question.id,
        rating: formState.rating,
        comment: formState.comment,
      });

      if (response?.success) {
        console.log("Review submitted successfully");
        setOpen(false);
        if (onSubmitted) {
          onSubmitted();
        } else {
          navigate(`/questions/view/${question.id}`);
        }
      } else {
        setError(
          `There was an error submitting the review: ${response?.message || "Unknown error"}`,
        );
      }
    } catch (error) {
      console.error("Failed to submit the review", error);
      setError(
        `There was an error submitting the review: ${error.message || "Unknown error"}`,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError("");
    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitReview();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography>Question Review</Typography>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && <Alert severity="error">{error}</Alert>}

          <Box sx={{ mb: 2 }}>
            <Typography variant="h6">Rating</Typography>
            <Rating
              name="rating"
              value={formState.rating}
              onChange={(event, newValue) => {
                setFormState((prev) => ({
                  ...prev,
                  rating: newValue,
                }));
              }}
              size="large"
              precision={0.5}
            />
          </Box>

          <TextField
            label="Comment"
            multiline
            rows={4}
            fullWidth
            value={formState.comment}
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                comment: e.target.value,
              }))
            }
            placeholder="Share your thoughts about this question..."
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant={"contained"}>
            Cancel
          </Button>
          <Button type="submit" variant={"outlined"} disabled={loading}>
            Submit Review
          </Button>
        </DialogActions>
        {loading && <Alert severity="info">Submitting your review...</Alert>}
      </form>
    </Dialog>
  );
};
